module.exports = __webpack_public_path__ + "static/media/galerija_2019 (3).59911944.jpg";